/* ============================================================
   BioActive+ — Privacy Policy · Dawn behaviours (vanilla)
   Boots once, re-runs on shopify:section:load so the Theme
   Editor stays live. Scoped to each .pp-page on the document.
   Uses a rAF scroll check for reveals + progress (reliable in
   the editor's iframe, unlike IntersectionObserver thresholds).
   ============================================================ */
(function () {
  "use strict";
  if (window.__ppBooted) { window.__ppInit && window.__ppInit(); return; }
  window.__ppBooted = true;

  var COOKIE_KEY = "bioactive_cookie_prefs";

  function readPrefs() {
    var p = { analytics: true, marketing: false };
    try {
      var s = JSON.parse(localStorage.getItem(COOKIE_KEY) || "null");
      if (s && typeof s === "object") p = Object.assign(p, s);
    } catch (e) {}
    return p;
  }
  function writePrefs(p) {
    try { localStorage.setItem(COOKIE_KEY, JSON.stringify(p)); } catch (e) {}
  }

  /* ---- per-page enhancement ---- */
  function enhance(page) {
    if (!page || page.__pp) return;
    page.__pp = true;

    /* TOC scroll-spy + reading progress */
    var tocLinks = Array.prototype.slice.call(page.querySelectorAll(".pp-toc a[data-target]"));
    var progFill = page.querySelector(".tf-prog i");
    var progPct = page.querySelector("[data-read-pct]");

    function targets() {
      return tocLinks
        .map(function (a) { return document.getElementById(a.getAttribute("data-target")); })
        .filter(Boolean);
    }

    tocLinks.forEach(function (a) {
      a.addEventListener("click", function (e) {
        var el = document.getElementById(a.getAttribute("data-target"));
        if (!el) return;
        e.preventDefault();
        var off = (parseInt(getComputedStyle(page).getPropertyValue("--pp-header-h")) || 0) + 24;
        var y = el.getBoundingClientRect().top + window.scrollY - off;
        window.scrollTo({ top: y, behavior: "smooth" });
        if (history.replaceState) history.replaceState(null, "", "#" + el.id);
      });
    });

    /* print */
    var printLink = page.querySelector("[data-pp-print]");
    if (printLink) printLink.addEventListener("click", function (e) { e.preventDefault(); window.print(); });

    /* cookie preferences */
    var prefs = readPrefs();
    var switches = Array.prototype.slice.call(page.querySelectorAll(".ck-switch[data-cookie]"));
    var statusEl = page.querySelector("[data-ck-status]");
    function statusText() {
      return "Analytics " + (prefs.analytics ? "on" : "off") + " \u00b7 Marketing " + (prefs.marketing ? "on" : "off");
    }
    function renderSwitches() {
      switches.forEach(function (sw) { sw.classList.toggle("on", !!prefs[sw.getAttribute("data-cookie")]); });
    }
    function setStatus(msg) { if (statusEl) statusEl.textContent = msg || statusText(); }
    renderSwitches(); setStatus();
    switches.forEach(function (sw) {
      sw.addEventListener("click", function () {
        var k = sw.getAttribute("data-cookie");
        prefs[k] = !prefs[k];
        renderSwitches(); setStatus();
      });
    });
    var saveBtn = page.querySelector("[data-ck-save]");
    var rejectBtn = page.querySelector("[data-ck-reject]");
    if (saveBtn) saveBtn.addEventListener("click", function () {
      writePrefs(prefs);
      document.dispatchEvent(new CustomEvent("pp:cookie-consent", { detail: Object.assign({}, prefs) }));
      setStatus("Saved \u2713 \u00b7 " + statusText());
      setTimeout(setStatus, 2200);
    });
    if (rejectBtn) rejectBtn.addEventListener("click", function () {
      prefs.analytics = false; prefs.marketing = false;
      renderSwitches(); writePrefs(prefs);
      document.dispatchEvent(new CustomEvent("pp:cookie-consent", { detail: Object.assign({}, prefs) }));
      setStatus("All optional cookies rejected");
      setTimeout(setStatus, 2200);
    });

    /* jump-to-cookies buttons (anywhere) */
    Array.prototype.slice.call(page.querySelectorAll("[data-pp-jump]")).forEach(function (b) {
      b.addEventListener("click", function () {
        var el = document.getElementById(b.getAttribute("data-pp-jump"));
        if (!el) return;
        var off = (parseInt(getComputedStyle(page).getPropertyValue("--pp-header-h")) || 0) + 16;
        window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - off, behavior: "smooth" });
      });
    });

    /* store refs for the shared scroll loop */
    page.__ppSpy = { tocLinks: tocLinks, targets: targets, progFill: progFill, progPct: progPct };
  }

  /* ---- shared scroll loop: reveals + spy + progress ---- */
  function scan() {
    var vh = window.innerHeight;
    // reveals
    var revs = document.querySelectorAll(".pp-page .reveal:not(.in)");
    for (var i = 0; i < revs.length; i++) {
      var r = revs[i].getBoundingClientRect();
      if (r.top < vh * 0.9 && r.bottom > 0) revs[i].classList.add("in");
    }
    // per-page spy + progress
    var pages = document.querySelectorAll(".pp-page");
    for (var p = 0; p < pages.length; p++) {
      var spy = pages[p].__ppSpy;
      if (!spy) continue;
      var secs = spy.targets();
      if (secs.length && spy.tocLinks.length) {
        var mid = window.scrollY + vh * 0.32;
        var cur = secs[0].id;
        for (var s = 0; s < secs.length; s++) {
          if (secs[s].offsetTop <= mid) cur = secs[s].id;
        }
        spy.tocLinks.forEach(function (a) { a.classList.toggle("on", a.getAttribute("data-target") === cur); });
      }
      var body = pages[p].querySelector(".pp-body");
      if (body && spy.progFill) {
        var start = body.offsetTop - vh * 0.5;
        var end = body.offsetTop + body.offsetHeight - vh * 0.5;
        var prog = Math.max(0, Math.min(1, (window.scrollY - start) / (end - start)));
        spy.progFill.style.width = (prog * 100).toFixed(1) + "%";
        if (spy.progPct) spy.progPct.textContent = Math.round(prog * 100) + "%";
      }
    }
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { scan(); ticking = false; });
  }

  window.__ppInit = function () {
    document.querySelectorAll(".pp-page").forEach(enhance);
    scan();
  };

  function boot() {
    window.__ppInit();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    // fail-safe: ensure nothing is stuck invisible if scroll never fires
    setTimeout(function () {
      document.querySelectorAll(".pp-page .reveal:not(.in)").forEach(function (el) { el.classList.add("in"); });
    }, 700);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  /* Theme Editor: re-enhance freshly loaded sections */
  document.addEventListener("shopify:section:load", function (e) {
    var sec = e.target;
    var pages = sec.querySelectorAll ? sec.querySelectorAll(".pp-page") : [];
    pages.forEach(function (pg) { pg.__pp = false; pg.__ppSpy = null; enhance(pg); });
    scan();
  });
})();
